import { ABTestCookie, Cookie, } from '@as-react/common-types';
import { generateActiveFilter, getProductGroupUniqueIds, makeProductGroupObjects, CookieUtil, HybridCookieUtil, } from '@as-react/common-utils';
import { Logger } from '@as-react/logger';
import { isAxiosError } from 'axios';
import { LOCATION_CHANGE } from 'connected-react-router';
import { all, fork, takeLatest, call, getContext, select, put } from 'redux-saga/effects';
import ProductsAPI from '../../../api/ProductsAPI';
import { ListerActionTypes } from '../../../enums/ActionEnums';
import MonetateUtil from '../../../util/MonetateUtil';
import { isPartialSearchResult } from '../../../util/ProductListerUtil';
import { updateCompareProducts } from '../../compare/sagas/CompareSagas';
import { filterActions } from '../../filter/actions/FilterActions.creators';
import { productGroupActions } from '../../productGroup/actions/ProductGroupActions.creators';
import { pushRouterState, getStoreData } from '../../router/sagas/RouterSagas';
import { listerActions } from '../actions/ListerActions.creators';
const getFredhopperSegment = (state) => state.lister.segment;
const getQueryInfo = (state) => state.url;
export function* updateListerProductsCompareStateSaga() {
    yield takeLatest(LOCATION_CHANGE, updateListerProductsCompareState);
}
function* updateListerProductsCompareState() {
    yield fork(updateCompareProducts);
}
export function* getListerProductsSaga() {
    yield takeLatest(ListerActionTypes.GET_LISTER_PRODUCTS, getListerProducts);
}
function* getListerProducts() {
    var _a;
    const aemConfigurationContext = yield getContext('aemConfiguration');
    const { authenticationConfig, fredHopperSearchUrl, isShopLanding } = aemConfigurationContext;
    const defaultListerSort = aemConfigurationContext.lister.sort.defaultValue;
    const queryInfo = yield select(getQueryInfo);
    const fredhopperSegment = yield select(getFredhopperSegment);
    const UUID = CookieUtil.get(Cookie._UUID);
    const aiSearchEnabled = new HybridCookieUtil().hasABCookie(ABTestCookie.AI_SEARCH);
    try {
        const searchResult = yield call(ProductsAPI.fetchProducts, queryInfo, fredHopperSearchUrl, defaultListerSort, authenticationConfig, fredhopperSegment, isShopLanding, Boolean(UUID), aiSearchEnabled);
        const productGroupUniqueIds = getProductGroupUniqueIds(searchResult.alternativeQueryResults);
        const productGroupObjects = makeProductGroupObjects(productGroupUniqueIds, searchResult.alternativeQueryResults);
        searchResult.productGroupUniqueIds = productGroupUniqueIds;
        yield put(listerActions.setListerStateAction(searchResult));
        yield put(productGroupActions.setProductGroups(productGroupObjects));
        if (isPartialSearchResult(searchResult.executionStatus)) {
            const products = Object.keys(productGroupObjects)
                .map(productGroupId => productGroupObjects[productGroupId].filter(item => item.productId))
                .flat();
            MonetateUtil.pushListerEvent(products);
        }
        if ((_a = queryInfo === null || queryInfo === void 0 ? void 0 : queryInfo.filter) === null || _a === void 0 ? void 0 : _a.length) {
            const activeFilters = {};
            queryInfo.filter.map((queryFilter) => {
                const activeFilter = generateActiveFilter(queryFilter.filterOn, queryFilter.filterValue, searchResult.filters);
                if (activeFilter) {
                    activeFilters[queryFilter.filterOn] = activeFilter;
                }
            });
            yield put(filterActions.setActiveFilters(activeFilters));
        }
        const partialRootState = yield select(getStoreData);
        yield fork(pushRouterState, partialRootState.url, partialRootState);
        yield put(listerActions.setListerIsLoadedAction());
    }
    catch (error) {
        if (!isAxiosError(error)) {
            Logger.logError(error);
        }
    }
}
export default function* listerSagas() {
    yield all([updateListerProductsCompareStateSaga(), getListerProductsSaga()]);
}
